// extracted by mini-css-extract-plugin
export const asText = "Button__asText__u7SRw Button__textOnly__12RWn";
export const atlasGrotesk = "'AtlasGrotesk'";
export const blueShadow = "Button__blueShadow__4Gxrc";
export const bold = "700";
export const button = "Button__button__1n9F4";
export const buttonContent = "Button__buttonContent__1zboi";
export const buttonText = "Button__buttonText__YDH5n";
export const checkmark = "Button__checkmark__MoSKU";
export const checkmarkIcon = "Button__checkmarkIcon__iIEzw";
export const chevron = "Button__chevron__nSbsi";
export const clickable = "Button__clickable__9A07k";
export const clickableDiv = "Button__clickableDiv__LYBFC";
export const fullHeight = "Button__fullHeight__t2KAE";
export const fullWidth = "Button__fullWidth__jB5xj";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const heavyShadow = "Button__heavyShadow__NSZ7k";
export const hollow = "Button__hollow__gU0zK";
export const icon = "Button__icon__iOFFz";
export const iconOnly = "Button__iconOnly__wadRE";
export const isDisabled = "Button__isDisabled__F43wT";
export const isSubmitting = "Button__isSubmitting__Avc7B";
export const large = "Button__large__0s7Ak";
export const lightShadow = "Button__lightShadow__bTsij";
export const loadingIconWrapper = "Button__loadingIconWrapper__D-Nd8";
export const medium = "Button__medium__jq48f";
export const micro = "Button__micro__SMVhB";
export const mini = "Button__mini__U022P";
export const outlined = "Button__outlined__8uMrW";
export const pushUp = "Button__pushUp__9a6Yp";
export const regular = "400";
export const responsive = "Button__responsive__0IvyQ";
export const responsiveTextFilled = "Button__responsiveTextFilled__6qfIo Button__textOnly__12RWn";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";
export const small = "Button__small__+W6Vc";
export const square = "Button__square__kg5Xy";
export const submittingChildrenVisible = "Button__submittingChildrenVisible__VW2rX";
export const submittingContent = "Button__submittingContent__V2d+y";
export const textOnly = "Button__textOnly__12RWn";
export const textOnlyBig = "Button__textOnlyBig__7lFN- Button__textOnly__12RWn";
export const tiny = "Button__tiny__kz-dF";
export const title = "Button__title__RuBZF";
export const wrapText = "Button__wrapText__2SO3n";